module.exports = __webpack_public_path__ + "img/airplanemode_ios@3x.c3d74ed2.jpg";